/**
 * doctor模块接口列表
 */
import axios from "@/api/http"; // 导入http中创建的axios实例
import base from "@/api/base"; // 导入接口域名列表
const doctor = {
  //  /api/counseling/user/getAllUser 获取所有咨询师用户
  queryUserPage(data) {
    return axios.get(
      `${base.baseURL_clinic}/user/getAllUser?currentPage=${data.currentPage}&pageSize=${data.pageSize}&key=${data.key}&phone=${data.phone}&inviteCode=${data.inviteCode}&sex=${data.sex}&date=${data.date}`);
  },
  queryUserCount(data) {
    return axios.get(
      `${base.baseURL_clinic}/user/getUserSize?key=${data.key}&phone=${data.phone}&inviteCode=${data.inviteCode}&sex=${data.sex}&date=${data.date}`);
  },
  createOneDiscount(data){
    return axios.post(
      `${base.baseURL_clinic}/discount/saveOneDiscount`, data);
  },
  createDiscount(data){
    return axios.post(
      `${base.baseURL_clinic}/discount/saveDiscount`, data);
  },

  queryUserList(data) {
    return axios.get(
      `${base.baseURL_clinic}/user/getAllUser?currentPage=${data.currentPage}&pageSize=${data.pageSize}&startTime=${data.startTime}&endTime=${data.endTime}&inviteCode=${data.inviteCode}`);
  },
  queryUserListCount(data) {
    return axios.get(
      `${base.baseURL_clinic}/user/getUserSize?startTime=${data.startTime}&endTime=${data.endTime}&inviteCode=${data.inviteCode}`);
  },
  queryConsultantCount(data) {
    return axios.get(
      `${base.baseURL_clinic}/user/getConsultantSize?key=${data.key}&phone=${data.phone}&onlineStatus=${data.onlineStatus}&sex=${data.sex}&date=${data.date}`);
  },
  queryConsultantPage(data) {
    return axios.get(
      `${base.baseURL_clinic}/user/getAllConsultant?currentPage=${data.currentPage}&pageSize=${data.pageSize}&key=${data.key}&phone=${data.phone}&onlineStatus=${data.onlineStatus}&sex=${data.sex}&date=${data.date}`);
  },
  queryConsultant(data) {
    return axios.get(
      `${base.baseURL_clinic}/userDetail/getByUserId?userId=${data.userId}`);
  },
  settingConsultant(data) {
    return axios.post(
      `${base.baseURL_clinic}/user/settingConsultant?userId=${data.id}&useVirtual=${data.useVirtual}&followerCount=${data.followerCount}&serviceCount=${data.servicesCount}`);
  },

  queryUserPost(data) {
    return axios.get(
      `${base.baseURL_clinic}/posts/getAllByUseId?currentPage=${data.currentPage}&pageSize=${data.pageSize}&userId=${data.id}&status=${data.status}`);
  },

  queryUserPostCount(data){
    return axios.get(
      `${base.baseURL_clinic}/posts/getCount?userId=${data.id}&status=${data.status}`);
  },
  uploadFile(formData) {
    return axios.post(
      `${base.baseURL_clinic}/file/upload`,formData,{
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
  },
  deleteFile(data) {
    return axios.post(
      `${base.baseURL_clinic}/file/delete?url=${data}`);
  },
  addVirtualUser(data){
    return axios.post(
      `${base.baseURL_clinic}/user/addUser`,data);
  },
  getVirtualUser(data){
    return axios.get(
      `${base.baseURL_clinic}/user/getAllVirtualUser?pageSize=${data.pageSize}&currentPage=${data.currentPage}`);
  },

  getConsultantByAdmin(){
    return axios.get(
      `${base.baseURL_clinic}/user/getConsultantByAdmin`);
  },
  getConsultantTime(data){
    return axios.get(
      `${base.baseURL_clinic}/user/getConsultantTime?userId=${data.userId}&date=${data.date}&slotDuration=${data.slotDuration}`);
  },

  changeOrder(data){
    return axios.post(
      `${base.baseURL_clinic}/order/changeOrder?userId=${data.userId}&startTime=${data.startTime}&endTime=${data.endTime}&orderId=${data.orderId}`);
  },

  getVirtualUserSize(){
    return axios.get(
      `${base.baseURL_clinic}/user/getAllVirtualUserSize`);
  },
  getComments(data){
    return axios.get(
      `${base.baseURL_clinic}/comments/getAll?postId=${data.postId}&pageSize=${data.pageSize}&currentPage=${data.currentPage}`);
  },

  addOneComments(data){
    return axios.post(
      `${base.baseURL_clinic}/comments/addOne`, data);
  },
  getReply(data){
    return axios.get(
      `${base.baseURL_clinic}/reply/getAll?commentId=${data.commentId}`);
  },
  deleteReply(data){
    return axios.post(
      `${base.baseURL_clinic}/reply/delete?replyId=${data.replyId}`);
  },
  deleteComment(data){
    return axios.post(
      `${base.baseURL_clinic}/comments/delete?commentId=${data.commentId}`);
  },

  addOneReply(data){
    return axios.post(
      `${base.baseURL_clinic}/reply/addOne`, data);
  },

  createPost(data){
    return axios.post(
      `${base.baseURL_clinic}/posts/createOne`,data);
  },

  editPost(data){
    return axios.post(
      `${base.baseURL_clinic}/posts/update`,data);
  },
  deletePosts(data){
    return axios.post(
      `${base.baseURL_clinic}/posts/delete?id=${data.id}`);
  },

  queryPostLabel() {
    return axios.get(
      `${base.baseURL_clinic}/label/get`);
  },


  // POST/department/queryDepartmentPage PC---（分页）查询科室列表------ygt
  queryDepartmentPage(params) {
    return axios.post(
      `${base.baseURL_clinic}department/queryDepartmentPage`,
      params
    );
  },
  // POST/hospital/queryHospitalPage PC---（分页）查询医院列表------ygt
  queryHospitalPage(params) {
    return axios.post(
      `${base.baseURL_clinic}/hospital/queryHospitalPage`,
      params
    );
  },
  // POST/tenant/page 分页查询租户信息(租户名称，租户类型模糊查询)------ygt--获取公司
  tenantPage(params) {
    return axios.post(`${base.baseURL}tenant/page`, params);
  },
  // POST/positionalTitle/queryPositionalTitlePage PC---（分页）查询职称列表------ygt
  queryPositionalTitlePage(params) {
    return axios.post(
      `${base.baseURL_clinic}positionalTitle/queryPositionalTitlePage`,
      params
    );
  },
  // POST/hospitalDoctor/saveDoctor PC医师端---医生信息新增/修改------ygt
  saveDoctor(params) {
    return axios.post(
      `${base.baseURL_clinic}hospitalDoctor/saveDoctor`,
      params
    );
  },

  // --------认证审核
  // POST/doctorQualification/queryDoctorQualificationPage 查询资质认证信息
  queryDoctorQualificationPage(params) {
    return axios.post(
      `${base.baseURL_clinic}doctorQualification/queryDoctorQualificationPage`,
      params
    );
  },
  // POST/doctorQualification/saveDoctorQualification 新增、修改资质认证信息
  saveDoctorQualification(params) {
    return axios.post(
      `${base.baseURL_clinic}doctorQualification/saveDoctorQualification`,
      params
    );
  },
  // POST/doctorClinic/queryDoctorClinicPage （分页）查询问诊记录列表------ygt
  queryDoctorClinicPage(params) {
    return axios.post(
      `${base.baseURL_clinic}doctorClinic/queryDoctorClinicPage`,
      params
    );
  },
  // DELETE /hospitalDoctor/removeById PC---删除职称信息---qph
  removeById(params) {
    return axios.delete(
      `${base.baseURL_clinic}hospitalDoctor/removeById?ids=` + params
    );
  },
  // POST/doctorCashRecord/queryDoctorCashRecordPage 查询提现信息记录
  queryDoctorCashRecordPage(params) {
    return axios.post(
      `${base.baseURL_clinic}doctorCashRecord/queryDoctorCashRecordPage`,
      params
    );
  },
  // 导诊员
  // POST/hospitalGuide/queryHospitalGuidePage（分页）查询导诊员列表------ygt
  queryHospitalGuidePage(params) {
    return axios.post(
      `${base.baseURL_clinic}hospitalGuide/queryHospitalGuidePage`,
      params
    );
  },
  // POST/hospitalGuide/saveHospitalGuide 导诊员新增/修改------ygt
  saveHospitalGuide(params) {
    return axios.post(
      `${base.baseURL_clinic}hospitalGuide/saveHospitalGuide`,
      params
    );
  },
  // POST/hospitalGuideClinic/queryHospitalGuideClinicPage PC---（分页）查询导诊列表------ygt
  queryHospitalGuideClinicPage(params) {
    return axios.post(
      `${base.baseURL_clinic}hospitalGuideClinic/queryHospitalGuideClinicPage`,
      params
    );
  },
  // DELETE/hospitalGuide/removeById PC---删除导诊员信息---qph
  removeById_guide(params) {
    return axios.delete(
      `${base.baseURL_clinic}hospitalGuide/removeById?ids=` + params
    );
  },
  //药师
  // POST/hospitalPharmacist/queryPharmacistPage PC---（分页）查询药师信息列表------ygt
  queryPharmacistPage(params) {
    return axios.post(
      `${base.baseURL_clinic}hospitalPharmacist/queryPharmacistPage`,
      params
    );
  },
  // POST/hospitalPharmacist/savePharmacist 新增、修改药师信息------ygt
  saveConsultant(params) {
    return axios.post(
      `${base.baseURL_clinic}/userDetail/update`,
      params
    );
  },
  // DELETE/hospitalPharmacist/removeById PC---删除药师信息---ygt
  removeById_pharma(params) {
    return axios.delete(
      `${base.baseURL_clinic}hospitalPharmacist/removeById?ids=` + params
    );
  }
};
export default doctor;



// WEBPACK FOOTER //
// ./src/network/user.js